const searchModes = {
  calendar: 'calendar',
}

export default searchModes

export { searchModes }
